<template>
  <DividerSeparator v-if="success" class="wide">
    <DecoratedButton
      type="link"
      :route="{ name: pages.AUTH_LOGIN }"
      class="wide short dark-blue"
      fontSize=".8em"
    >
      LOGIN
    </DecoratedButton>
  </DividerSeparator>
  <DividerSeparator v-else-if="failed" class="wide">
    <div>Your reset link has expired</div>
  </DividerSeparator>
  <DividerSeparator class="wide" v-else>
    <Loader />
    <div slot="title">Resetting Two-Factor Authentication</div>
  </DividerSeparator>
</template>

<script>
import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "auth-two-factor-reset",
  data: function() {
    return {
      success: false,
      failed: false,
      loading: false
    };
  },
  components: { Loader },
  created: function() {
    setTimeout(() => {
      this.services.UserResource.authCodeReset({
        id: this.$route.params.id
      })
        .then(() => {
          this.success = true;
        })
        .catch(err => {
          this.failed = true;
        });
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
